//# sourceMappingURL=websites.mjs.map
/// <reference types="./websites.d.mts" />
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $button from "../../../ds/ds/components/button.mjs";
import * as $callout from "../../../ds/ds/components/callout.mjs";
import * as $checkbox from "../../../ds/ds/components/checkbox.mjs";
import * as $input from "../../../ds/ds/components/input.mjs";
import * as $l from "../../../ds/ds/components/layout.mjs";
import * as $table from "../../../ds/ds/components/table.mjs";
import * as $typography from "../../../ds/ds/components/typography.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $bit_array from "../../../gleam_stdlib/gleam/bit_array.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $set from "../../../gleam_stdlib/gleam/set.mjs";
import * as $file from "../../../magellan/magellan/file.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $e from "../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $automations_effects from "../../admin/effects/automations.mjs";
import * as $sitemap from "../../admin/sitemap.mjs";
import * as $card from "../../components/card.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";
import * as $common from "../../view/common.mjs";

class SitemapProps extends $CustomType {
  constructor(sitemap_urls, filtered, filter_input, set_filter_input, set_applied_filter, selected, set_selected, batch_size_input, set_batch_size_input, effect_dispatch) {
    super();
    this.sitemap_urls = sitemap_urls;
    this.filtered = filtered;
    this.filter_input = filter_input;
    this.set_filter_input = set_filter_input;
    this.set_applied_filter = set_applied_filter;
    this.selected = selected;
    this.set_selected = set_selected;
    this.batch_size_input = batch_size_input;
    this.set_batch_size_input = set_batch_size_input;
    this.effect_dispatch = effect_dispatch;
  }
}

const default_sitemap_batch_size = 50;

function select_all_checkbox(visible, selected, set_selected) {
  let selected_count = $list.count(
    visible,
    (_capture) => { return $set.contains(selected, _capture); },
  );
  let all_selected = !$list.is_empty(visible) && (selected_count === $list.length(
    visible,
  ));
  return $checkbox.checkbox(
    (() => {
      if (all_selected) {
        return new $checkbox.Checked();
      } else if (selected_count === 0) {
        return new $checkbox.Unchecked();
      } else {
        return new $checkbox.Indeterminate();
      }
    })(),
    $list.is_empty(visible),
    (_) => {
      if (all_selected) {
        return set_selected((_) => { return $set.new$(); });
      } else {
        return set_selected((_) => { return $set.from_list(visible); });
      }
    },
  );
}

function sitemap_url_list(urls, selected, set_selected) {
  return $l.column(
    toList([$l.overflow("auto"), $l.styles(toList([$css.max_height_("400px")]))]),
    toList([]),
    toList([
      $table.table(
        toList([]),
        toList([
          $table.headers(
            toList([
              (() => {
                let _pipe = $table.custom_header(
                  select_all_checkbox(urls, selected, set_selected),
                );
                return $table.fit(_pipe);
              })(),
              $table.header("URL"),
            ]),
          ),
          $table.body(
            $list.map(
              urls,
              (url) => {
                return $table.row(
                  toList([
                    (() => {
                      let _pipe = $table.cell(
                        $checkbox.checkbox(
                          $checkbox.checked($set.contains(selected, url)),
                          false,
                          (is_checked) => {
                            if (is_checked) {
                              return set_selected(
                                (_capture) => {
                                  return $set.insert(_capture, url);
                                },
                              );
                            } else {
                              return set_selected(
                                (_capture) => {
                                  return $set.delete$(_capture, url);
                                },
                              );
                            }
                          },
                        ),
                      );
                      return $table.stop_cell_propagation(_pipe);
                    })(),
                    $table.cell(
                      $typography.text($typography.sm, $typography.regular, url),
                    ),
                  ]),
                );
              },
            ),
          ),
        ]),
      ),
    ]),
  );
}

function sitemap_result(props) {
  let sitemap_urls = props.sitemap_urls;
  let filtered = props.filtered;
  let filter_input = props.filter_input;
  let set_filter_input = props.set_filter_input;
  let set_applied_filter = props.set_applied_filter;
  let selected = props.selected;
  let set_selected = props.set_selected;
  let batch_size_input = props.batch_size_input;
  let set_batch_size_input = props.set_batch_size_input;
  let effect_dispatch = props.effect_dispatch;
  let _block;
  let _pipe = $int.parse(batch_size_input);
  _block = $result.unwrap(_pipe, default_sitemap_batch_size);
  let batch_size = _block;
  let url_list_element = $redraw.use_memo(
    () => { return sitemap_url_list(filtered, selected, set_selected); },
    [filtered, selected],
  );
  if (sitemap_urls instanceof $remote.NotLoaded) {
    return $h.none();
  } else if (sitemap_urls instanceof $remote.Loading) {
    return $callout.info(
      toList([]),
      toList([
        $callout.content(
          toList([]),
          toList([$h.text("Fetching and parsing the sitemap…")]),
        ),
      ]),
    );
  } else if (sitemap_urls instanceof $remote.Errored) {
    let message = sitemap_urls[0];
    return $callout.error(
      toList([]),
      toList([$callout.content(toList([]), toList([$h.text(message)]))]),
    );
  } else {
    let urls = sitemap_urls[0];
    return $l.column(
      toList([$l.gap(8)]),
      toList([]),
      toList([
        $h.text(
          $int.to_string($list.length(urls)) + " links found in the sitemap.",
        ),
        $l.row(
          toList([$l.gap(8)]),
          toList([]),
          toList([
            (() => {
              let _pipe$1 = $input.value(filter_input);
              let _pipe$2 = $input.placeholder(_pipe$1, "Filter, e.g. /us-en/");
              let _pipe$3 = $input.on_input(_pipe$2, set_filter_input);
              let _pipe$4 = $input.on_submit(
                _pipe$3,
                () => { return set_applied_filter(filter_input); },
              );
              return $input.input(_pipe$4);
            })(),
            $button.secondary(
              toList([
                $e.on_click((_) => { return set_applied_filter(filter_input); }),
              ]),
              toList([$h.text("Apply filter")]),
            ),
          ]),
        ),
        $h.text(
          (($int.to_string($list.length(filtered)) + " links match, ") + $int.to_string(
            $set.size(selected),
          )) + " selected.",
        ),
        url_list_element,
        $l.row(
          toList([$l.align("center"), $l.justify("end"), $l.gap(8)]),
          toList([]),
          toList([
            $typography.text($typography.sm, $typography.medium, "Batch size"),
            (() => {
              let _pipe$1 = $input.value(batch_size_input);
              let _pipe$2 = $input.type_(_pipe$1, "number");
              let _pipe$3 = $input.min(_pipe$2, "1");
              let _pipe$4 = $input.on_input(_pipe$3, set_batch_size_input);
              let _pipe$5 = $input.style(
                _pipe$4,
                $css.class$(toList([$css.width_("80px")])),
              );
              return $input.input(_pipe$5);
            })(),
            $button.secondary(
              toList([
                $a.disabled($set.is_empty(selected)),
                $e.on_click(
                  (_) => {
                    let _block$1;
                    let _pipe$1 = selected;
                    let _pipe$2 = $set.to_list(_pipe$1);
                    _block$1 = $sitemap.build_urlset_xml(_pipe$2);
                    let content = _block$1;
                    let $ = $file.download(
                      "sitemap.xml",
                      $bit_array.from_string(content),
                    );
                    
                    return undefined;
                  },
                ),
              ]),
              toList([$h.text("Download XML")]),
            ),
            $button.primary(
              toList([
                $a.disabled($set.is_empty(selected) || (batch_size <= 0)),
                $e.on_click(
                  (_) => {
                    let urls$1 = $set.to_list(selected);
                    let _pipe$1 = $automations_effects.generate_sitemap_zip(
                      urls$1,
                      batch_size,
                    );
                    effect_dispatch(_pipe$1);
                    return undefined;
                  },
                ),
              ]),
              toList([$h.text("Download ZIP")]),
            ),
          ]),
        ),
      ]),
    );
  }
}

export function view() {
  return $redraw.component_(
    "Websites",
    (_) => {
      let dispatch = $store.use_dispatch();
      let effect_dispatch = $store.use_effect_dispatch();
      let store = $store.use_state();
      let $ = $redraw.use_state("");
      let url_input = $[0];
      let set_url_input = $[1];
      let $1 = $redraw.use_state("");
      let filter_input = $1[0];
      let set_filter_input = $1[1];
      let $2 = $redraw.use_state("");
      let applied_filter = $2[0];
      let set_applied_filter = $2[1];
      let $3 = $redraw.use_state_($set.new$());
      let selected = $3[0];
      let set_selected = $3[1];
      let $4 = $redraw.use_state($int.to_string(default_sitemap_batch_size));
      let batch_size_input = $4[0];
      let set_batch_size_input = $4[1];
      let _block;
      let $5 = store.sitemap_urls;
      if ($5 instanceof $remote.Loaded) {
        let urls = $5[0];
        _block = urls;
      } else {
        _block = toList([]);
      }
      let all_urls = _block;
      let filtered = $redraw.use_memo(
        () => { return $sitemap.filter(all_urls, applied_filter); },
        [all_urls, applied_filter],
      );
      return $l.column(
        toList([$l.gap(12)]),
        toList([]),
        toList([
          $common.page_title("Websites"),
          $card.card_custom_width(
            1500,
            toList([]),
            toList([
              $card.title(toList([]), toList([$h.text("Sitemap Batch Tool")])),
              $card.body(
                toList([]),
                toList([
                  $h.text(
                    "Paste a sitemap XML URL to list its links. You can then ",
                  ),
                  $h.text(
                    "filter them, select a subset, and download either a single ",
                  ),
                  $h.text(
                    "XML file or a ZIP of batched sitemap files (50 links each).",
                  ),
                ]),
              ),
              $l.column(
                toList([$l.gap(8)]),
                toList([]),
                toList([
                  $input.input(
                    (() => {
                      let _pipe = $input.value(url_input);
                      let _pipe$1 = $input.placeholder(
                        _pipe,
                        "https://example.com/sitemap.xml",
                      );
                      return $input.on_input(_pipe$1, set_url_input);
                    })(),
                  ),
                  $l.row(
                    toList([$l.justify("end")]),
                    toList([]),
                    toList([
                      $button.primary(
                        toList([
                          $a.disabled(url_input === ""),
                          $e.on_click(
                            (_) => {
                              set_selected((_) => { return $set.new$(); });
                              set_filter_input("");
                              set_applied_filter("");
                              dispatch(
                                new $msg.Sitemap(
                                  new $msg.UserRequestedSitemapParse(url_input),
                                ),
                              );
                              return undefined;
                            },
                          ),
                        ]),
                        toList([$h.text("Fetch sitemap")]),
                      ),
                    ]),
                  ),
                  sitemap_result(
                    new SitemapProps(
                      store.sitemap_urls,
                      filtered,
                      filter_input,
                      set_filter_input,
                      set_applied_filter,
                      selected,
                      set_selected,
                      batch_size_input,
                      set_batch_size_input,
                      effect_dispatch,
                    ),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}
